import { render, staticRenderFns } from "./aftersale_order_complaint_edit.vue?vue&type=template&id=2263e0bf&scoped=true"
import script from "./aftersale_order_complaint_edit.vue?vue&type=script&lang=js"
export * from "./aftersale_order_complaint_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263e0bf",
  null
  
)

export default component.exports